import { ToWords } from 'to-words'

import {
  getMixedNumberHTML,
  updateRequiredQuantityValues,
  toUpper,
  cart,
  setBundleDescriptionNew,
  setBundlePriceNew,
  equalWidths,
  checkIfVariantIsAvailable,
  disableBundleSubmitButton
} from './functions'

// Document load/ready promise, calls 'ready' method when completed
HTMLDocument.prototype.ready = function () {
  return new Promise(function (resolve, reject) {
    if (document.readyState === 'complete') {
      resolve(document)
    } else {
      document.addEventListener('DOMContentLoaded', function () {
        resolve(document)
      })
    }
  })
}

const toWords = new ToWords({
  localeCode: 'en-US',
  converterOptions: {
    currency: false,
    ignoreDecimal: false,
    ignoreZeroCurrency: false
  }
})

document.ready().then(function () {
  const patternPage = document.getElementById('shopify-section-product-template-patterns')
  if (!patternPage) {
    return
  }

  cart.updateElements()
  cart.setupCloseButton()

  const patternSizeOptions = document.getElementById('js-pattern-sizes')
  const patternYarns = document.getElementById('js-pattern-yarns')
  const patternBundleContents = document.getElementById('js-bundle-contents')
  const patternBundleSubmit = document.getElementById('js-bundle-submit-button')
  const patternShowBundle = document.getElementById('js-bundle-open-button')
  const patternBundle = document.getElementById('js-bundle-wrapper')
  const buttons = '#js-bundle-wrapper button.ProductForm__Item'
  const prepend = 'Color: '

  // Pattern Sizing
  if (
    window.bundleInfo &&
    patternBundle &&
    patternSizeOptions &&
    patternYarns &&
    patternBundleContents &&
    patternBundleSubmit &&
    patternShowBundle
  ) {


    patternShowBundle.addEventListener('click', function (e) {
      e.preventDefault()
      const form = document.querySelector('.Product__InfoWrapper form')

      patternBundle.classList.add('visible')
      // form.scrollIntoView({behavior: 'smooth', block: 'start'});

      setTimeout(() => {
        equalWidths(buttons, 25)

        window.addEventListener('resize.optimized', function () {
          equalWidths(buttons, 25)
        })
      }, 250)
    })

    const increaseQuantity = document.querySelectorAll('[data-action=increase]')
    const decreaseQuantity = document.querySelectorAll('[data-action=decrease]')

    let title

    if (patternBundleContents.dataset.title) {
      title = toUpper(patternBundleContents.dataset.title)
    }
    const bundleDescriptionBase = `Your bundle contains the selected yarn `
    // const priceButtonBase = `Add Bundle to Cart <span class="bundle-button-dot">&#xb7;</span> $`;
    const priceButtonBase = `Add Bundle to Cart <span class="Button__SeparatorDot"></span> $`

    const popovers = document.querySelectorAll('.Popover--Bundle')
    const bundleVariantOutOfStock = document.querySelectorAll('.ProductForm__BundleVariantOutOfStock')
    const parts = []

    for (const popover of popovers) {
      // The "select menu" button that opens the popover when clicked
      const buttonEl = document.querySelector(`.ProductForm__Item[aria-controls="${popover.id}"]`)
      const quantityEl = document.querySelector(`[data-quantity-for="${popover.id}"]`)
      const options = popover.querySelectorAll('button')
      const selectedValueEl = buttonEl.querySelector('.ProductForm__SelectedValue')

      const part = {
        popover,
        buttonEl,
        quantityEl,
        selectedValueEl,
        options
      }

      parts.push(part)

      // Initial disabling of submit button if a selected variant is unavailable
      let selectedOption = popover.querySelector('.is-selected')

      if (selectedOption && selectedOption.dataset.productType === 'yarn') {
        if (selectedOption.closest('button')) {
          selectedOption = selectedOption.closest('button')
        }

        const yarnIndex = Number(selectedOption.dataset.yarnIndex)
        const yarnVariant = Number(selectedOption.dataset.variant)
        const yarnVariantsArray = window.bundleInfo.yarns[yarnIndex]
        const $outOfStockMessage = bundleVariantOutOfStock[yarnIndex]

        if (checkIfVariantIsAvailable(yarnVariant, yarnVariantsArray) === false) {
          disableBundleSubmitButton(patternBundleSubmit)
          $outOfStockMessage.classList.add('out-of-stock')
        }



      }

      // Set the content for the default selected element
      const defaultVariantElement = popover.querySelector('button.is-selected')

      if (defaultVariantElement) {
        // Includes the color swatch for the variant
        const defaultContent = defaultVariantElement.querySelector('.content-for-select')

        if (defaultContent) {
          selectedValueEl.innerHTML = defaultContent.innerHTML
        }
      }

      for (const option of options) {
        option.addEventListener('click', function () {
          // Remove the class from all options and child elements,
          // since the Popover code seems to add it to elements inside the option sometimes
          for (const o of options) {
            o.classList.remove('is-selected')
            const selectedChildren = o.querySelectorAll('.is-selected')

            for (const child of selectedChildren) {
              child.classList.remove('is-selected')
            }
          }

          option.classList.add('is-selected')

          setBundleDescriptionNew(bundleDescriptionBase, parts, patternBundleContents)

          if (option.dataset.productType === 'yarn') {
            const yarnIndex = Number(option.dataset.yarnIndex)
            const yarnVariant = Number(option.dataset.variant)
            const yarnVariantsArray = window.bundleInfo.yarns[yarnIndex]
            const $outOfStockMessage = bundleVariantOutOfStock[yarnIndex]




            if (checkIfVariantIsAvailable(yarnVariant, yarnVariantsArray) === true) {
              // Set bundle price, but also remove the disabled attribute if present
              setBundlePriceNew(priceButtonBase, parts, patternBundleSubmit, true)
              $outOfStockMessage.classList.remove('out-of-stock')
            } else {
              disableBundleSubmitButton(patternBundleSubmit)
              $outOfStockMessage.classList.add('out-of-stock')
            }
          } else if (option.dataset.productType === 'needle') {
            // Set bundle price, but also remove the disabled attribute if present
            setBundlePriceNew(priceButtonBase, parts, patternBundleSubmit, true)
          }

          // Update "select" menu selected option text and color swatch
          const content = option.querySelector('.content-for-select')
          selectedValueEl.innerHTML = content.innerHTML
        })
      }
    }

    setBundlePriceNew(priceButtonBase, parts, patternBundleSubmit)
    setBundleDescriptionNew(bundleDescriptionBase, parts, patternBundleContents)

    const sizeInputs = patternSizeOptions.querySelectorAll('input')
    const quantityInputs = patternYarns.querySelectorAll('input')

    for (const input of sizeInputs) {
      // Initial setup
      const { value } = input
      const html = getMixedNumberHTML(value)

      // Display mixed number if required
      if (input.nextElementSibling && input.nextElementSibling.nodeName === 'LABEL') {
        input.nextElementSibling.innerHTML = html
      }

      input.addEventListener('click', function () {
        // Update yarn required value for each yarn color
        updateRequiredQuantityValues(input, quantityInputs)
        setBundleDescriptionNew(bundleDescriptionBase, parts, patternBundleContents)
        setBundlePriceNew(priceButtonBase, parts, patternBundleSubmit)
      })
    }

    for (const part of parts) {
      const { quantityEl } = part

      quantityEl.addEventListener('input', function (event) {
        if (Number(quantityEl.value) <= 0) {
          quantityEl.setAttribute('value', 1)
        }

        setBundleDescriptionNew(bundleDescriptionBase, parts, patternBundleContents)
        setBundlePriceNew(priceButtonBase, parts, patternBundleSubmit)
      })
    }

    for (const increase of increaseQuantity) {
      const input = increase.parentNode.querySelector('input')
      let { value } = input
      increase.addEventListener('click', function () {
        value = input.value

        input.setAttribute('value', Number(value) + 1)
        input.value = Number(value) + 1

        setBundleDescriptionNew(bundleDescriptionBase, parts, patternBundleContents)
        setBundlePriceNew(priceButtonBase, parts, patternBundleSubmit)
      })
    }

    for (const decrease of decreaseQuantity) {
      const input = decrease.parentNode.querySelector('input')
      let { value } = input

      decrease.addEventListener('click', function () {
        value = input.value

        if (Number(value) <= 1) {
          input.setAttribute('value', 1)
          input.value = 1
        } else {
          input.setAttribute('value', Number(value) - 1)
          input.value = Number(value) - 1
        }

        setBundleDescriptionNew(bundleDescriptionBase, parts, patternBundleContents)
        setBundlePriceNew(priceButtonBase, parts, patternBundleSubmit)
      })
    }

    patternBundleSubmit.addEventListener('click', function (e) {
      document.dispatchEvent(new CustomEvent('theme:loading:start'))

      const products = []

      for (const part of parts) {
        const selected = part.popover.querySelector('.is-selected')
        const quantity = Number(part.quantityEl.value)
        const id = Number(selected.dataset.variant)

        if (id) {
          products.push({
            id,
            quantity
          })
        }
      }

      const pdf_id = Number(patternBundleSubmit.dataset.productId)
      // Add the pattern PDF product
      products.push({
        id: pdf_id,
        quantity: 1
      })

      e.preventDefault()

      if (products.length > 0) {
        fetch(`${window.theme.localeRootUrl}/cart/add.js`, {
          body: JSON.stringify({
            items: products
          }),
          credentials: 'same-origin',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
          }
        }).then(function (response) {
          console.log(response)
          document.dispatchEvent(new CustomEvent('theme:loading:end'))
          if (response.ok) {
            const element = document.querySelector('section.Product')

            // We simply trigger an event so the mini-cart can re-render
            element.dispatchEvent(
              new CustomEvent('product:added', {
                bubbles: true,
                detail: {
                  variant: products[0].id,
                  quantity: products[0].quantity
                }
              })
            )
          } else {
            response.json().then(function (content) {
              const errorMessageElement = document.createElement('span')
              errorMessageElement.className = 'ProductForm__Error Alert Alert--error'
              errorMessageElement.innerHTML = content.description
              setTimeout(function () {
                errorMessageElement.remove()
              }, 2500)
            })
          }
        })
      }
    })
  }

  const contrastNumbers = document.querySelectorAll('.contrast-number')
  for (const $number of contrastNumbers) {
    const number = Number($number.textContent)

    if (number === 0) {
      $number.textContent = ''
    } else {
      const words = toWords.convert(number)
      $number.textContent = words
    }
  }

  const originalButton = document.querySelector('#js-bundle-submit-button');
  const newButton = document.querySelector('#disabled-button');
  if (originalButton.disabled && newButton) {
    newButton.style.display = "none"
  }
})
